interface DynamicConfig {
	test_var: string;
	APP_API_GRAPHQL_URL: string;
	APP_API_REST_URL: string;
	APP_OKTA_CLIENT_ID_AUTH: string;
	APP_OKTA_ISSUER: string;
	APP_OKTA_USER_CLIENT_ID_AUTH: string;
	APP_OKTA_USER_ISSUER: string;
	APP_AMCHART_LICENCE: string;
	APP_GTAG: string;
	APP_VERSION: string;
	APP_VIDEO_TUTO_URL_FR: string;
	APP_VIDEO_TUTO_URL_EN: string;
	APP_VIDEO_INTRO_EN: string;
	APP_MATOMO_BASE_URL: string;
	APP_MATOMO_SITE_ID: number;
	APP_MATOMO_CURRENT_COMPANY_CD_ID: number;
	APP_MATOMO_AUTH_CONTEXT_CD_ID: number;
	REACT_APP_AZURE_OIDC_AUTHORITY: string;
	REACT_APP_AZURE_OIDC_CLIENT_ID: string;
	REACT_APP_AZURE_OIDC_REDIRECT_URI: string;
	REACT_APP_AZURE_OIDC_REDIRECT_URI_SILENT: string;
	REACT_APP_AZURE_OIDC_SCOPE: string;
}

const defaultConfig: DynamicConfig = {
	test_var: '', //'TEST VAR DEFAULT VALUE',
	APP_API_GRAPHQL_URL: '', //'http://localhost:8000/graphql',
	APP_API_REST_URL: '', // 'http://localhost:8000/rest',
	APP_OKTA_CLIENT_ID_AUTH: '', //'0oa1ok6m8lwNeLtsp0h8',
	APP_OKTA_ISSUER: '', // 'https://rfa.okta.com',
	APP_OKTA_USER_CLIENT_ID_AUTH: '', // '0oa4aq8mz4npEmw3Z0x7',
	APP_OKTA_USER_ISSUER: '', //'https://sienna-im-sandbox.oktapreview.com',
	APP_AMCHART_LICENCE: '', //'AM5C328868560',
	APP_GTAG: '', //'G-PYJ6HB6H7X',
	APP_VERSION: '', //'1.0.0',
	APP_VIDEO_TUTO_URL_FR: '', //'https://streamable.com/l2egvv',
	APP_VIDEO_TUTO_URL_EN: '', //'https://streamable.com/ueform',
	APP_VIDEO_INTRO_EN: '', //'https://streamable.com/cqk21v',
	APP_MATOMO_BASE_URL: '',
	APP_MATOMO_SITE_ID: 0,
	APP_MATOMO_AUTH_CONTEXT_CD_ID: 0,
	APP_MATOMO_CURRENT_COMPANY_CD_ID: 0,
	REACT_APP_AZURE_OIDC_AUTHORITY: '',
	REACT_APP_AZURE_OIDC_CLIENT_ID: '',
	REACT_APP_AZURE_OIDC_REDIRECT_URI: '',
	REACT_APP_AZURE_OIDC_REDIRECT_URI_SILENT: '',
	REACT_APP_AZURE_OIDC_SCOPE: '',
};

class GlobalConfig {
	config: DynamicConfig = defaultConfig;
	notDefinedYet = true;

	public get(): DynamicConfig {
		if (this.notDefinedYet) {
			throw new Error('Global config has not been defined yet.');
		} else {
			return this.config;
		}
	}

	public set(value: DynamicConfig): void {
		if (this.notDefinedYet) {
			this.config = value;
			this.notDefinedYet = false;
		} else {
			throw new Error('Global config has already been defined');
		}
	}
}

export const globalConfig = new GlobalConfig();

export const globalConfigUrl = '/config.json';
